module.exports = __webpack_public_path__ + "static/media/linkCard_explore.4b8584f1.svg";